import { EnumPartnershipType, type ApiUserPartnershipInformation } from '@Model';

export interface AuthSession {
    partnershipId: string;
    partnershipType: EnumPartnershipType;
    clientId: string;
    mandantId: string;
    subpath: string;
}

export interface Session extends AuthSession {}

export interface SessionContextPayload {
    current: Session;
    update: (value: Session | null) => void;
    partnerships: ApiUserPartnershipInformation[];
    setPartnerships: (partnerships: ApiUserPartnershipInformation[]) => void;
}

export const sessionStorageKey = 'synqo.cloud.auth.session';

export const emptySession: Session = {
    partnershipId: '',
    partnershipType: EnumPartnershipType.Internal,
    clientId: '',
    subpath: '',
    mandantId: '',
};
